// External
import { MUIDataTableColumn, MUIDataTableMeta } from 'mui-datatables';

export const getMetaData = (columnName: string, columns: MUIDataTableColumn[], meta: MUIDataTableMeta) =>
  meta.rowData[columns.findIndex((c) => c.name === columnName)]
